document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.splide-slider-images').forEach(function (el) {
    const splide = new Splide(el, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '1rem',
      arrows: true,
      pagination: false,
      breakpoints: {
        1024: { perPage: 2 },
        768: { perPage: 2 }
      }
    });

    // Cherche une progress bar dans CE slider uniquement
    const progressBar = el.closest('.slider-images-wrapper')?.querySelector('.my-slider-progress-bar');

    if (progressBar) {
      splide.on('mounted move', function () {
        const end = splide.Components.Controller.getEnd() + 1;
        const index = splide.index + 1;
        const progress = Math.min((index / end) * 100, 100);
        progressBar.style.width = progress + '%';
      });
    }

    splide.mount();
  });
});






document.addEventListener('DOMContentLoaded', function () {
    const splide = new Splide('#splide-selection-produits', {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      gap: '1rem',
      arrows: true,
      pagination: false,
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 }
      }
    });

    splide.mount();
  });
console.log("Custom JS bien chargé ✅");


document.querySelectorAll('select').forEach(select => {
  select.addEventListener('change', () => {
    if (select.value === '') {
      select.style.fontWeight = 'normal';
    } else {
      select.style.fontWeight = 'bold';
    }
  });

  // Initialiser le style au chargement
  if (select.value === '') {
    select.style.fontWeight = 'normal';
  } else {
    select.style.fontWeight = 'bold';
  }
});
